import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";

export const VARIABLES = [
  ["DATE", "Date du courrier"], ["REFERENCE", "Référence"], ["DESTINATAIRE", "Destinataire"], ["FONCTION_DESTINATAIRE", "Fonction du destinataire"],
  ["ENTREPRISE", "Entreprise / organisation"], ["ADRESSE", "Adresse"], ["EMAIL", "E-mail"], ["TELEPHONE", "Téléphone"], ["OBJET", "Objet"],
  ["NOM_EXPEDITEUR", "Nom de l'expéditeur"], ["FONCTION_EXPEDITEUR", "Fonction de l'expéditeur"], ["SERVICE", "Service / direction"],
];
export const STATUS_STYLE = {
  "BROUILLON": "bg-slate-100 text-slate-700", "À VALIDER": "bg-amber-100 text-amber-800", "VALIDÉ": "bg-emerald-100 text-emerald-800",
  "ENVOYÉ": "bg-sky-100 text-sky-800", "ARCHIVÉ": "bg-zinc-200 text-zinc-600",
};
export const longDate = (d) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : "");
const esc = (s) => String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export function varValues(l, cfg) {
  const svc = (cfg?.services || []).find((s) => s.code === l.service);
  return {
    DATE: longDate(l.date), REFERENCE: l.reference || "", DESTINATAIRE: l.destinataire, FONCTION_DESTINATAIRE: l.destinataire_fonction,
    ENTREPRISE: l.entreprise, ADRESSE: l.adresse, EMAIL: l.email, TELEPHONE: l.telephone, OBJET: l.objet,
    NOM_EXPEDITEUR: l.expediteur, FONCTION_EXPEDITEUR: l.expediteur_fonction, SERVICE: svc?.nom || l.service || "",
  };
}

// Remplace {{VAR}} ; keepMissing laisse la variable si la valeur est vide
export function fillVars(html, l, cfg, keepMissing = false) {
  const v = varValues(l, cfg);
  return (html || "").replace(/\{\{\s*([A-Z_]+)\s*\}\}/g, (m, k) => (k in v && (v[k] || !keepMissing) ? esc(v[k] || "") : m));
}

export async function lcall(fn, ok) {
  try { const r = await fn(); if (ok) toast.success(ok); return r.data ?? true; }
  catch (e) { toast.error(apiErr(e)); return null; }
}

export const emptyLetter = (user) => ({
  date: new Date().toISOString().slice(0, 10), type: "Lettre", objet: "", service: "", destinataire: "", destinataire_fonction: "", entreprise: "",
  adresse: "", email: "", telephone: "", expediteur: user?.name || "", expediteur_fonction: "", ref_precedente: "", lieu: "", signataire_id: "",
  avec_cachet: false, contenu_html: "<p>Madame, Monsieur,</p><p></p><p>Nous vous prions d'agréer, Madame, Monsieur, l'expression de nos salutations distinguées.</p>",
  recipient_link: null, template_id: "",
});

export const letterApi = {
  config: () => api.get("/letters/config").then((r) => r.data),
  company: () => api.get("/settings").then((r) => r.data.company || {}).catch(() => ({})),
};
